class LWInhoud extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const nummer = this.getAttribute('nr') || '01';
        const link = this.getAttribute('link') || '#';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                width: 100%;
            }

            .item-container:focus-visible {
                outline: 3px solid #ffec3d;
                outline-offset: 4px;
            }

            .item-container {
                display: flex;
                align-items: center;
                padding: 12px 0;
                border-top: 3px solid #ff0080;
                gap: 16px;
                text-decoration: none;
                cursor: pointer;
            }

            .number {
                font-size: 72px;
                font-weight: 800;
                line-height: 0.8;
                color: white;
                opacity: 0.9;
                transition: color 0.2s ease, opacity 0.2s ease;
                width: 1.15ch;
                flex: 0 0 auto;
                text-align: left;
                font-variant-numeric: tabular-nums;
            }

            .content {
                flex: 1;
                min-width: 0;
                color: white;
            }

            ::slotted(h2) {
                margin: 0 0 15px 0;
                font-size: 40px;
                /* FIX: !important moet BUITEN de var() staan */
                font-weight: var(--inhoud-h2-weight, 900) !important;
                letter-spacing: 2px;
                line-height: 1.1;
            }


            ::slotted(h3) {
                margin: 0 0 10px 0;
                font-size: 30px;
                letter-spacing: 1px;
                font-weight: 900;
            }

    
            ::slotted(.inhoud-tekst) {
                margin: 0;
                font-size: 25px;
                font-weight: 400;
                line-height: 30px;
                opacity: 0.85;
                color: #ffffff;
                transition: color 0.2s ease, opacity 0.2s ease;
                text-transform: none;
                display: block;
            }



            /* Verwijder de lijn bij het laatste item als je dat mooier vindt */
            :host(:last-of-type) .item-container {
                border-bottom: none;
            }

            @media (min-width: 768px) {
                .item-container {
                    gap: 18px;
                    padding: 28px 0;
                }
                .number {
                    font-size: 120px;
                    line-height: 0.8;
                }

                :host(:hover) .number,
                :host(:hover) ::slotted(.inhoud-tekst) {
                    color: #ffec3d;
                    opacity: 1;
                }
            }
        </style>

        <a class="item-container" href="${link}">
            <div class="number">${nummer}</div>
            <div class="content">
                <slot></slot>
            </div>
        </a>
        `;
    }
}

customElements.define('lw-inhoud', LWInhoud);